import React, { Component } from 'react'
import * as R from 'ramda'
import i18n from 'i18next'

import Select from '../../form/Select'
import Input from '../../form/Input'

class ObjectivesGrid extends Component {
    categories = ['sales', 'marketing', 'strategic']

    constructor(props) {
        super(props)

        const { store } = props
        const { template } = store

        console.log('template', JSON.stringify(template, null, 4))

        if (template) {
            const { questions } = template
            this.state = Object.keys(questions).reduce((map, id, index) => {
                const { satisfaction, importance, targets } = questions[id]
                const category = this.categories[index]
                return Object.assign(map, {
                    [category]: {
                        objectives: id,
                        satisfaction,
                        importance,
                        targets: R.clone(targets),
                    },
                })
            }, {
                title: template.title,
            })
        } else {
            this.state = {}
        }

        store.onSave = this.save
    }

    save = () => {
        const { title } = this.state
        const body = {
            id: 'objectives-grid',
            title,
        }

        const questions = this.categories.reduce((map, category) => {
            const {
                objectives,
                importance,
                satisfaction,
                targets,
            } = this.state[category]
            const { questionId, target, achieved, none} = targets
            return Object.assign(map, {
                [objectives.toUpperCase()]: {
                    importance: importance.toUpperCase(),
                    satisfaction: satisfaction.toUpperCase(),
                    targets: {
                        questionId: questionId.toUpperCase(),
                        target,
                        achieved,
                        none,
                    },
                },
            })
        }, {})

        body.questions = questions
        return body
    }

    changeQuestion = ({ value, name }) => {
        const lens = R.lensPath(name)
        const state = R.clone(this.state)
        console.log('state', R.set(lens, value, state))
        this.setState(R.set(lens, value, state))
    }

    targetOptions = (category) => {
        const { store } = this.props
        const { selectedLocale, surveyLocale } = store
        const { questionMap } = store
        const { targets } = R.pathOr({}, [category], this.state)

        if (R.isNil(targets)) return null

        const question = R.pathOr(null, [targets.questionId.toLowerCase()], questionMap)
        const options = R.pathOr([], ['optionSetX', 'options'], question)
            .map((option) => ({
                value: option.id,
                label: option.getTitle(selectedLocale, surveyLocale, R.pathOr('en_GB', ['metadata', 'initialLocale'], question)),
            }))

        const achievedPath = [category, 'targets', 'achieved']
        const targetedPath = [category, 'targets', 'target']
        const nonePath = [category, 'targets', 'none']

        return (
            <div style={{ display: 'flex', gap: '10px' }}>
                <Select
                    label={i18n.t('surveyBuilder.modal.template.quantity_targeted')}
                    name={targetedPath}
                    options={options}
                    onBlur={this.changeQuestion}
                    defaultValue={R.pathOr('', targetedPath, this.state).toLowerCase()}
                />
                <Select
                    label={i18n.t('surveyBuilder.modal.template.quantity_achieved')}
                    name={achievedPath}
                    options={options}
                    onBlur={this.changeQuestion}
                    defaultValue={R.pathOr('', achievedPath, this.state).toLowerCase()}
                />
                <Select
                    label={i18n.t('surveyBuilder.modal.template.none_of_these')}
                    name={nonePath}
                    options={options}
                    onBlur={this.changeQuestion}
                    defaultValue={R.pathOr('', nonePath, this.state).toLowerCase()}
                />
            </div>
        )
    }

    targets = (category) => {
        const { store } = this.props
        const { pageQuestions } = store

        const path = [category, 'targets', 'questionId']
        return (
            <>
                <Select
                    label={i18n.t('surveyBuilder.modal.template.targets')}
                    name={path}
                    options={pageQuestions}
                    onBlur={this.changeQuestion}
                    defaultValue={R.pathOr('', path, this.state).toLowerCase()}
                />
                {this.targetOptions(category)}
            </>
        )
    }

    objectives = (category) => {
        const { store } = this.props
        const { parentQuestions } = store

        const path = [category, 'objectives']

        return (
            <Select
                label={i18n.t('surveyBuilder.modal.template.objectives')}
                name={path}
                options={parentQuestions}
                onBlur={this.changeQuestion}
                defaultValue={R.pathOr('', path, this.state).toLowerCase()}
            />
        )
    }

    satisfaction = (category) => {
        const { store } = this.props
        const { pageQuestions } = store

        const path = [category, 'satisfaction']

        return (
            <Select
                label={i18n.t('surveyBuilder.modal.template.satisfaction')}
                name={path}
                options={pageQuestions}
                onBlur={this.changeQuestion}
                defaultValue={R.pathOr('', path, this.state).toLowerCase()}
            />
        )
    }

    importance = (category) => {
        const { store } = this.props
        const { pageQuestions } = store

        const path = [category, 'importance']

        return (
            <Select
                label={i18n.t('surveyBuilder.modal.template.importance')}
                name={path}
                options={pageQuestions}
                onBlur={this.changeQuestion}
                defaultValue={R.pathOr('', path, this.state).toLowerCase()}
            />
        )
    }

    render() {
        return (
            <div style={{ maxHeight: '60vh', overflow: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Input
                    name={['title']}
                    label={i18n.t('gen_title')}
                    onBlur={this.changeQuestion}
                    defaultValue={R.pathOr('', ['title'], this.state)}
                />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <h3>{i18n.t('questions')}</h3>
                    {this.categories.map((category) => (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <h4>{category}</h4>
                            {this.objectives(category)}
                            {this.satisfaction(category)}
                            {this.importance(category)}
                            {this.targets(category)}
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default ObjectivesGrid
